import {
  ParlorHeadSection,
  DTypeMainHead,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  BTypeSangjoService,
  DTypeParlorList,
  DTypeCardView,
  ATypeBreadCrumb,
  GOI_WEB_URL,
} from "goi_common";
import { GetServerSideProps, GetStaticPaths, GetStaticProps } from "next";
import parlors from "goi_common/src/constants/parlors_detail.json";

import React from "react";
import { ParlorDetailProps, CTypeTabs } from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";
import Head from "next/head";
import { Box, Stack } from "@mui/material";

const { regionColor, targetSidos } = parlorRegion;

function getByValue(map: Map<number, any>, searchValue: any) {
  for (const [key, value] of map.entries()) {
    if (key === searchValue) return value;
  }
}

// export const getStaticPaths: GetStaticPaths = async () => {
//   const paths = parlors
//     .filter((res) => targetSidos.includes(res.sido))
//     .map((parlor) => ({
//       params: {
//         companyname: `${parlor.companyname}-(${getByValue(
//           FUNERAL_SIDO,
//           Number(parlor.sido)
//         )} ${getByValue(
//           FUNERAL_SIGUNGU.get(Number(parlor.sido)) as any,
//           Number(parlor.sigungu)
//         )})`,
//       },
//     }));

//   return {
//     paths,
//     fallback: false,
//   };
// };

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const code = params?.companyname as string;
  const companyname = code.split("-")[0];
  let parlor;
  let district;
  let name = "";
  let description = "";

  if (companyname) {
    parlor = parlors.find((parlor) => parlor.companyname === companyname);
    if (parlor) {
      name = parlor.companyname;

      district = parlor.address.slice(0, 2);
      if (parlor.address.split(" ")[0].length == 4)
        district = parlor.address[0] + parlor.address[2];

      description = `${parlor.companyname}에서 이용 가능한 상조 서비스 용품 차량 인력
      합리적으로 진행하세요. 장례식장 이용료 제휴 할인 여부 확인.`;
    }
  }

  return {
    props: {
      defaultParlor: parlor,
      pageDescription: description,
      pageKeywords: `${parlor?.companyname} 장례 서비스, ${parlor?.companyname} 얼마, ${parlor?.companyname} 앰뷸런스, ${parlor?.companyname} 수의, ${parlor?.companyname} 유골함, ${parlor?.companyname} 도우미, ${parlor?.companyname} 비용, ${parlor?.companyname} 할인, ${parlor?.companyname} 전화번호`,
      pageOgTitle: `(${district}) ${parlor?.companyname} 장례 서비스 추천 및 요약 :: 전라광주장례추천포털`,
      pageOgDescription: description,
      pageOgImage: parlor?.images[0]?.url || "",
      hasError: !parlor,
    },
  };
};

export default function flower({
  defaultParlor,
  pageOgTitle,
}: {
  defaultParlor: ParlorDetailProps;
  pageOgTitle: string;
}) {
  const regionParlors = parlors.filter((res) => targetSidos.includes(res.sido));
  const sidoName = FUNERAL_SIDO.get(Number(defaultParlor.sido));
  const sigunguName = FUNERAL_SIGUNGU.get(Number(defaultParlor.sido))?.get(
    Number(defaultParlor.sigungu)
  );

  const carouselItems = regionParlors.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.honam-funeralcenter.co.kr/funeral-recommend-item/${defaultParlor.companyname}-(${sidoName} ${sigunguName})/`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionParlors.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};

  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
        {regionParlors.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>

      <ATypeBreadCrumb
        firstItem={{
          text: `장례식장 추천`,
          href: GOI_WEB_URL + "/match/request/",
          event: {
            domain: "honam",
            path: "funeral_service",
            trigger_and_target: "br_crumb_mth_req",
          },
        }}
        secondItem={{
          text: `${sidoName} 장례식장`,
          href: `/region-list-summary/장례식장 리스트 (${sidoName})/`,
          event: {
            domain: "honam",
            path: "funeral_service",
            trigger_and_target: "br_crumb_sido_prlr_list",
          },
        }}
        thirdItem={{
          text: `${sigunguName} 장례식장`,
          href: `/region-list-summary/장례식장 리스트 (${sidoName}-${sigunguName})/`,
          event: {
            domain: "honam",
            path: "funeral_service",
            trigger_and_target: "br_crumb_sigungu_prlr_list",
          },
        }}
        goiHomeEvent={{
          domain: "honam",
          path: "funeral_service",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />
      <ParlorHeadSection
        component={
          <>
            <DTypeMainHead
              sidoName={sidoName}
              sigunguName={sigunguName}
              mainColor={regionColor}
              defaultParlor={defaultParlor}
              title={`${defaultParlor.companyname} 상조 서비스`}
              managed_type={defaultParlor.managed_type}
            />
          </>
        }
      />
      <Stack style={{ background: "white" }}>
        <CTypeTabs
          mainColor={regionColor}
          href={`funeral-recommend-item/${defaultParlor.companyname}-(${sidoName} ${sigunguName})`}
          selectTab="상조 서비스"
          defaultParlor={defaultParlor}
          event={{
            domain: "honam",
            path: "funeral_service",
            trigger_and_target: "CType_tab",
          }}
        />
      </Stack>

      <BTypeSangjoService
        defaultParlor={defaultParlor}
        mainColor={regionColor}
        event={{
          domain: "honam",
          path: "funeral_service",
          trigger_and_target: "goi_call",
        }}
      />
      <Stack padding="20px">
        <Box width="100%" height="1px" style={{ background: "black" }} />
      </Stack>
      <Stack style={{ padding: "20px" }}>
        <DTypeParlorList
          binsoAveragePrice
          sido={defaultParlor.sido}
          title={`${sidoName}의 다른 장례식장`}
          CardViewType={(res) => (
            <DTypeCardView
              address={res.address}
              descriptions={[
                `평균 ${Number(res.binso_average_charge).toLocaleString()}원`,
              ]}
              key={res.companyname}
              name={res.companyname}
              href={`/funeral-recommend-item/${defaultParlor.companyname}-(${sidoName} ${sigunguName})/`}
              imgSrc={res.images[0] ? res.images[0].url : ""}
              event={{
                domain: "honam",
                path: "funeral_service",
                trigger_and_target: "uv_prlr_detail",
              }}
            />
          )}
        />
      </Stack>
    </>
  );
}
